<template>
  <BaseModal
    :heading="$t('global.actions.edit_note')"
    parentRoute="calendar"
    small
  >
    <NoteForm />
  </BaseModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NoteForm from '../forms/NoteForm.vue';

export default defineComponent({
  components: {
    NoteForm,
  },
});
</script>
